import { render, staticRenderFns } from "./PromocionalCodeHeader.vue?vue&type=template&id=1801be1a&scoped=true"
import script from "./PromocionalCodeHeader.vue?vue&type=script&lang=js"
export * from "./PromocionalCodeHeader.vue?vue&type=script&lang=js"
import style0 from "./PromocionalCodeHeader.vue?vue&type=style&index=0&id=1801be1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1801be1a",
  null
  
)

export default component.exports